module.exports = __webpack_public_path__ + "static/media/13․051.8dd37767.webp";